/**
 * Last-ditch fallback shown by Sentry.ErrorBoundary when a React render
 * throws and no closer boundary caught it. Stays intentionally minimal —
 * we can't trust any app-side context (router, theme, supabase client)
 * survived the crash, so this is a pure presentational component with a
 * full-page reload as the only recovery action.
 */
export function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#0A1628',
        color: '#F8FAFC',
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      }}
      role="alert"
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ fontSize: 14, color: '#94A3B8', marginBottom: 24, lineHeight: 1.5 }}>
          GolfAuth Pro hit an error and couldn't recover. The issue has been logged and the team will take a look.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: '#C9A84C',
            color: '#0A1628',
            border: 'none',
            padding: '10px 20px',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
